const parseJwt = token => {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  const parsedPayload = JSON.parse(jsonPayload);
  return parsedPayload;
};

const getToken = (instance) => {
  return new Promise(resolve => {
    const account = instance.getAllAccounts()[0];
    
    const accessTokenRequest = {
      scopes: ["api://bc51f172-76d1-4b35-81ad-2baec5e9e9b2/default"],
      account: account
    };
    
    instance.acquireTokenSilent(accessTokenRequest).then(function(accessTokenResponse) {
      let accessToken = accessTokenResponse.accessToken;
      resolve(accessToken);
    }).catch(function (error) {
      console.error(error);
    });
  });
};

const getUser = (token) => {
  const user = parseJwt(token);
  return user;
};

const securityCheck = (userPermissions, componentName, action) => {
  if (!userPermissions) {
    return false;
  }
  const componentPerms = userPermissions[componentName];
  if (componentPerms && componentPerms[action]) {
    return componentPerms[action];
  } else {
    return false;
  }
};

export { 
  getToken, 
  securityCheck,
  getUser
};